import { Component, ElementRef, ViewChild } from '@angular/core'
import { MatDatepickerInputEvent } from '@angular/material/datepicker'
import { ApexLegend, ChartComponent } from 'ng-apexcharts'
import { SharedService } from 'src/app/shared/services/shared.service'
import { PointingSystemService } from '../../services/pointing-system.service'
import { Subscription } from 'rxjs'
import { Width } from 'ngx-owl-carousel-o/lib/services/carousel.service'

@Component({
	selector: 'app-points-statistics',
	templateUrl: './points-statistics.component.html',
	styleUrl: './points-statistics.component.scss',
})
export class PointsStatisticsComponent {
	@ViewChild('dateInput') dateInput!: ElementRef
	@ViewChild('chart') chart!: ChartComponent
	filter = {
		countryId: 224,
		fromDate: '',
		toDate: '',
	}
	today = new Date()
	labels: string[] = []
	values: number[] = []
	public chartOptions!: Partial<any>
	legend: ApexLegend = {
		show: true,
		formatter: function (seriesName, opts) {
			// Construct the string to return
			return seriesName + ' - ' + opts.w.globals.series[opts.seriesIndex]
		},
		fontSize: '16px',
		width: 400,
		horizontalAlign: 'center',
	}
	subscription = new Subscription()
	constructor(
		private SharedService: SharedService,
		private PointingSystemService: PointingSystemService
	) {
		this.SharedService.headerTitle.next(`SIDEBAR.POINTS_STATISTICS`)
		this.initChart([], [])
	}
	ngOnInit() {
		this.getStatistics()
	}
	getStatistics() {
		this.subscription.add(
			this.PointingSystemService.pointsStatistics(this.filter).subscribe({
				next: (res: any) => {
					this.labels = Object.keys(res.result)
					this.values = Object.values(res.result)
				},
				complete: () => {
					this.initChart(this.labels, this.values)
				},
			})
		)
	}

	initChart(labels: string[], values: number[]) {
		this.chartOptions = {
			plotOptions: {
				pie: {
					customScale: 0.8,

					donut: {
						labels: {
							show: true,
							total: {
								show: true,
								showAlways: true,
							},
							value: {},
						},
					},
				},
			},

			series: values,
			chart: {
				width: '1000px',
				type: 'donut',
			},
			labels: labels,

			responsive: [
				{
					breakpoint: 480,
					options: {
						chart: {
							width: 200,
						},
						legend: {
							position: 'bottom',
							show: true,
							fontSize: '2px',
							customLegendItems: ['ad', 'bd'],
						},
					},
				},
			],
		}
	}

	changeDate() {
		!(this.filter.toDate < this.filter.fromDate && this.filter.toDate)
			? this.getStatistics()
			: null
	}
	onDestroy() {
		this.subscription.unsubscribe()
	}
}
